import { render } from "./ChatWidget.vue?vue&type=template&id=1eedbfe8&scoped=true"
import script from "./ChatWidget.js?vue&type=script&lang=js&external"
export * from "./ChatWidget.js?vue&type=script&lang=js&external"

import "./ChatWidget.vue?vue&type=style&index=0&id=1eedbfe8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1eedbfe8"],['__file',"src/components/ChatWidget/ChatWidget/ChatWidget.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1eedbfe8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1eedbfe8', __exports__)) {
    api.reload('1eedbfe8', __exports__)
  }
  
  module.hot.accept("./ChatWidget.vue?vue&type=template&id=1eedbfe8&scoped=true", () => {
    api.rerender('1eedbfe8', render)
  })

}


export default __exports__